import errorMessages from '@common/constants/errorMessages';
import { PAYMENT_PLAN_NOTE_MAX_LENGTH } from '@rental-manager/constants/PaymentConstants';
import { centsToDollars, dollarsToCents } from '@common/paymentsUtils/currencyUtils';
import { isEmpty, isObjectEmpty } from '@common/paymentsUtils/inputValidator';

export const isPaymentPlanNoteLengthValid = (value: string) => value.length <= PAYMENT_PLAN_NOTE_MAX_LENGTH;

export const isPaymentPlanAmountValid = (amount: string, maxAmount: number) => {
  const amountInCents = parseInt(dollarsToCents(amount), 10);
  return amountInCents <= maxAmount;
};

export const isPaymentPlanMinAmountValid = (amount: string, minAmount: number) => {
  const amountInCents = parseInt(dollarsToCents(amount), 10);
  return amountInCents >= minAmount;
};

const validatePaymentPlanAmount = (
  paymentPlanAmount: string,
  maxAmountCents: number,
  minAmountCents: number,
): Record<string, string> => {
  const errors: any = {};
  if (isEmpty(paymentPlanAmount)) {
    errors.paymentPlanAmount = errorMessages.PAYMENT_PLAN_AMOUNT_EMPTY;
    return errors;
  }

  if (!isPaymentPlanAmountValid(paymentPlanAmount, maxAmountCents)) {
    const paymentPlanMaxAmountInDollars = centsToDollars(maxAmountCents, { style: 'effectiveShort' });
    errors.paymentPlanAmount = errorMessages.PAYMENT_PLAN_MAX_AMOUNT(paymentPlanMaxAmountInDollars);
  }

  if (!isPaymentPlanMinAmountValid(paymentPlanAmount, minAmountCents)) {
    const paymentPlanMinAmountInDollars = centsToDollars(minAmountCents);
    errors.paymentPlanAmount = errorMessages.PAYMENT_PLAN_MIN_AMOUNT(paymentPlanMinAmountInDollars);
  }
  return errors;
};

const validatePaymentPlanNotes = (paymentPlanNote: string): Record<string, string> => {
  const errors: any = {};
  if (isEmpty(paymentPlanNote)) {
    errors.paymentPlanNote = errorMessages.PAYMENT_PLAN_NOTES_EMPTY;
  }
  return errors;
};

export const validateInputs = (paymentPlanFeaturePermissions, paymentPlanValue, setPaymentPlanValue) => {
  const { paymentPlanAmount, paymentPlanNote } = paymentPlanValue;

  const errors = {
    ...validatePaymentPlanAmount(
      paymentPlanAmount,
      Number(paymentPlanFeaturePermissions.amountLimit),
      Number(paymentPlanFeaturePermissions.amountMinimum),
    ),
    ...validatePaymentPlanNotes(paymentPlanNote),
  };
  setPaymentPlanValue({
    ...paymentPlanValue,
    errors,
  });
  return isObjectEmpty(errors);
};
